import { useState } from 'react';
import { useSelector } from 'react-redux';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Modal from '@deprecated-ui/common/Modal';
import tradingModalStore from 'global/TradingModal/store';
import { checkIsAutoOrderTncAgreed } from 'global/TradingModal/RealTradingModal/TransactionModal/utils';
import { selectors as profileSelectors } from 'lib/entities/profile';
import { postSmartOrderTnC } from 'lib/api/smartOrder';
import { BuyOrderType } from 'global/Securities/types/transaction';
import useTradingStore from 'features/transaction/useTradingStore';
import realTradingStore from '../store';
import { AutoBuySubmitButton, Checkbox } from '../styled';

const title =
  'Dengan menggunakan fitur Auto Order, saya menyatakan dan memahami bahwa:';

const checkboxDescription =
  'Saya menyetujui Syarat & Ketentuan Penggunaan Auto Order di atas.';

const tnc = [
  'Saya mengerti risiko penggunaan fitur Auto Order.',
  'Fitur Auto Order hanya membantu proses otomatisasi dalam bertransaksi. Pemesanan melalui Auto Order adalah sepenuhnya tanggung jawab pengguna, PT. Stockbit Sekuritas Digital tidak bertanggung jawab atas segala kerugian yang mungkin bisa terjadi.',
  'Sistem akan mulai melakukan pengecekan harga pada pukul 09:00:00 WIB.',
  'Proses pembentukan harga pada saat sesi pembukaan dapat mempengaruhi order saya.',
  'Eksekusi Auto Order bergantung pada antrian di bursa dimana ada kemungkinan terjadinya jeda waktu.',
  'Pemesanan melalui Auto Order tidak menjamin akan sesuai dengan harga dan jumlah yang saya harapkan.',
  'Stockbit berhak melakukan penghentian sementara fasilitas automated trading jika terdapat resiko perdagangan yang mungkin timbul untuk menghindari kerugian yang tidak diinginkan',
];

interface iAutoOrderTncModal {
  autoOrderType: string;
  visible: boolean;
  onAccept?: () => void;
  closeModal: () => void;
}

function AutoOrderTncModal({
  autoOrderType,
  visible,
  closeModal,
  onAccept,
}: iAutoOrderTncModal) {
  const setOrderType = realTradingStore((s) => s.setOrderType);
  const setOrderTypeGen = useTradingStore((s) => s.setOrderType);
  const openFromWidget = useTradingStore((s) => s.openFromWidget);
  const onSubmitAutoOrderTnC = useTradingStore((s) => s.onSubmitAutoOrderTnC);
  const setAutoBuy = tradingModalStore((state) => state.setAutoBuy);

  const [isTncAgree, setTncAgree] = useState<boolean>(false);
  const {
    data: { username },
  } = useSelector(profileSelectors);

  const saveLogTnc = async () => {
    try {
      const logTnc = JSON.parse(localStorage.getItem('logTnc')) || [];
      const response = await postSmartOrderTnC({ product: autoOrderType });
      if (response?.data?.message !== 'success') {
        return;
      }

      if (!checkIsAutoOrderTncAgreed(username, autoOrderType)) {
        logTnc.push({
          username,
          product: autoOrderType,
        });
        localStorage.setItem('logTnc', JSON.stringify(logTnc));
      }

      return;
    } catch (error) {
      console.error(error);
    }
  };

  const onTncAgreed = () => {
    saveLogTnc();
    if (openFromWidget) {
      setOrderTypeGen(BuyOrderType.AutoBuy);
    } else setOrderType(BuyOrderType.AutoBuy);
    setAutoBuy(true);
    if (onSubmitAutoOrderTnC) {
      setTimeout(onSubmitAutoOrderTnC, 200);
    } else onAccept?.();
  };

  return (
    <Modal visible={visible} centered onCancel={closeModal}>
      <Text size="20px" align="center" family="bold" padding="15px">
        Syarat & Ketentuan
      </Text>
      <Flex direction="column" padding="20px">
        <Flex
          direction="column"
          padding="20px"
          style={{
            border: '1px solid rgb(237, 237, 237)',
            borderRadius: '5px',
          }}
        >
          {/* @ts-expect-error */}
          <Text family="bold" mb="10px">
            {title}
          </Text>
          <ul style={{ marginLeft: '-20px' }}>
            {tnc.map((item) => (
              <li key={item}>
                <Text padding="5px">{item}</Text>
              </li>
            ))}
          </ul>
        </Flex>

        <Checkbox
          onChange={() => setTncAgree(!isTncAgree)}
          style={{ marginTop: '15px' }}
        >
          <Text>{checkboxDescription}</Text>
        </Checkbox>
      </Flex>

      <AutoBuySubmitButton
        disabled={!isTncAgree}
        onClick={onTncAgreed}
        type="primary"
        radius="4px"
        block
        height="40px"
      >
        <Text align="inherit" color="inherit" family="bold" size="16px">
          Submit
        </Text>
      </AutoBuySubmitButton>
    </Modal>
  );
}

export default AutoOrderTncModal;
